function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { getFilterText, handleFilterToggle, keyDownHandler } from '../utils/filterItemUtils';
// eslint-disable-next-line import/named
import { Icon, TooltipHost } from '@fluentui/react';
import { Constants } from '../utils/constants';
import { InternalLink } from './internalLink';
import SpzaComponent from './spzaComponent';
class FilterItem extends SpzaComponent {
    getClassName() {
        let className = this.props.className || 'spza_filterItem';
        className += ' filterItemName' + (this.props.isActive ? ' spza_activeFilter' : '');
        className += this.props.shouldShowFilterBoldStyle ? '' : ' spza_parent-filter-bold-disable';
        return className;
    }
    getFilterItemInner() {
        const filter = this.props.filter;
        const filterText = getFilterText(this.context, filter, this.props.showExpandedIcon, this.props.href);
        const className = this.getClassName();
        const filterId = filter.FilterID || null;
        const filterClassname = `filterText ${this.props.isEmbed ? 'embedFilterButton' : ''} ${this.props.filterTextClass}`;
        const hostStyles = {
            root: {
                marginLeft: 5
            }
        };
        const role = this.props.role || 'checkbox';
        const isActive = !!this.props.isActive;
        const clickHandler = this.props.onClickHandle || handleFilterToggle(this.props.category, this.props.queryValue, isActive, this.props.href, Constants.Telemetry.ActionModifier.FilterPane, this.props.onClick);
        const otherProps = _object_spread({}, this.props.otherProps);
        if (role === 'checkbox') {
            otherProps['aria-checked'] = isActive;
        }
        return /*#__PURE__*/ _jsxs("label", {
            className: `${className} filterItemName`,
            children: [
                !this.props.hideCheckbox && /*#__PURE__*/ _jsx("input", {
                    type: "checkbox",
                    "aria-label": filterText,
                    checked: isActive,
                    onChange: clickHandler,
                    onKeyDown: (event)=>{
                        keyDownHandler(event, clickHandler);
                    }
                }),
                /*#__PURE__*/ _jsxs("span", {
                    children: [
                        /*#__PURE__*/ _jsxs(InternalLink, _object_spread_props(_object_spread({
                            role: "checkbox",
                            className: filterClassname,
                            "aria-checked": isActive,
                            accEnabled: this.props.accEnabled,
                            href: this.props.href,
                            onClick: clickHandler
                        }, otherProps), {
                            children: [
                                this.props.iconClassName ? /*#__PURE__*/ _jsx("div", {
                                    className: "productIcon",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: this.props.iconClassName
                                    })
                                }) : null,
                                filterText
                            ]
                        }), filterId),
                        this.props.tooltip && /*#__PURE__*/ _jsx(TooltipHost, {
                            styles: hostStyles,
                            content: this.context.loc(this.props.tooltip),
                            children: /*#__PURE__*/ _jsx(Icon, {
                                className: "ms-Icon ms-Icon--Info"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "resultCount",
                    children: this.props.resultCount ? this.props.resultCount : null
                })
            ]
        });
    }
    renderImpl() {
        return this.props.role === 'button' ? /*#__PURE__*/ _jsx("div", {
            className: "c-checkbox filterItem",
            children: this.getFilterItemInner()
        }) : /*#__PURE__*/ _jsx("li", {
            className: "c-checkbox filterItem",
            children: this.getFilterItemInner()
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0);
    }
}
export { FilterItem as default };
FilterItem.contextTypes = {
    loc: PropTypes.func,
    buildHref: PropTypes.func,
    renderErrorModal: PropTypes.func
};
